import '@inboxsdk/core/background.js'
import './types'

const DOIST_HEADERS_PLATFORM_KEY = 'Doist-Platform'
const DOIST_HEADERS_WRAPPER_VERSION_KEY = 'Doist-WrapperVersion'
const PLATFORM_HEADER_VALUE = 'gmail-legacy'
const WRAPPER_NAME = 'TodoistForGmail'

const { version } = chrome.runtime.getManifest()

function updateHeaderRulesForGmailTabs() {
    chrome.tabs.query(
        { url: ['http://mail.google.com/*', 'https://mail.google.com/*'] },
        (tabs) => {
            const tabIds = tabs.map((tab) => tab.id).filter((id): id is number => id !== undefined)

            chrome.declarativeNetRequest.updateSessionRules(
                {
                    removeRuleIds: [1],
                    addRules:
                        tabIds.length > 0
                            ? [
                                  {
                                      id: 1,
                                      priority: 1,
                                      action: {
                                          type: 'modifyHeaders' as chrome.declarativeNetRequest.RuleActionType,
                                          requestHeaders: [
                                              {
                                                  header: DOIST_HEADERS_PLATFORM_KEY,
                                                  operation:
                                                      'set' as chrome.declarativeNetRequest.HeaderOperation,
                                                  value: PLATFORM_HEADER_VALUE,
                                              },
                                              {
                                                  header: DOIST_HEADERS_WRAPPER_VERSION_KEY,
                                                  operation:
                                                      'set' as chrome.declarativeNetRequest.HeaderOperation,
                                                  value: `${WRAPPER_NAME}/${version}`,
                                              },
                                          ],
                                      },
                                      condition: {
                                          urlFilter: '||app.todoist.com/*',
                                          tabIds,
                                      },
                                  },
                              ]
                            : [],
                },
                () => {
                    console.log('Declarative network request rules updated for tabs:', tabIds)
                },
            )
        },
    )
}

updateHeaderRulesForGmailTabs()

chrome.tabs.onUpdated.addListener(
    (tabId: number, changeInfo: chrome.tabs.OnUpdatedInfo, tab: chrome.tabs.Tab) => {
        const { url } = tab

        if (!url?.includes('mail.google.com') || changeInfo.status !== 'complete') {
            return
        }

        updateHeaderRulesForGmailTabs()

        chrome.scripting.executeScript({
            target: { tabId },
            func: () =>
                // Use setTimeout here to give the page time to load and for
                // the TDOpts to be set
                setTimeout(() => {
                    if (!top.TDOpts) return

                    const { email_href, email_title } = top.TDOpts

                    if (!email_href || !email_title) return

                    const dataToSend = `${email_href}--/--${email_title}`
                    // Find the iframe element with id "todoist_iframe"
                    const todoistIframe = document.getElementById(
                        'todoist_iframe',
                    ) as HTMLIFrameElement | null
                    if (todoistIframe) {
                        // Access the window object of the iframe to call postMessage
                        const todoistIframeWindow = todoistIframe.contentWindow
                        if (todoistIframeWindow) {
                            try {
                                // Call postMessage on the window object of the iframe
                                todoistIframeWindow.postMessage(dataToSend, '*')
                            } catch {
                                // Do nothing. Would be great to log this, but 🤷🏻‍♂️
                            }
                        }
                    }
                }, 200),
        })
    },
)

chrome.tabs.onRemoved.addListener(() => {
    updateHeaderRulesForGmailTabs()
})
